import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';

// Apis
import { CompanyTreeApiImpl } from './apis/impls/company-api';
import { GetCompanyTreeApi } from './apis/company-tree-api';
import { GetCompanyNameApi } from './apis/company-name-api';

// Services
import { CompanyService } from './services/company-service';
import { CompanyServiceImpl } from './services/impls/company-service';

export const companyModule = new ContainerModule((bind: interfaces.Bind) => {
    // Bind Apis
    bind(GetCompanyTreeApi).to(CompanyTreeApiImpl);
    bind(GetCompanyNameApi).to(CompanyTreeApiImpl);

    // Bind Services
    bind(CompanyService).to(CompanyServiceImpl);
});
